import { clsx } from 'clsx';
import { Box } from '~/components/Layout/Box';
import colorStyles from '~/components/Utilities/ColourCombinations/ColourCombinations.module.css';
import styles from './Card.module.css';
import type { CardProps } from './Card.types';

const Card = ({
  children,
  colour = 'defaultBackground',
  hasBorder,
  isCentered,
  isClickable,
  isElevated,
  isSelected,
  rounded,
  fullHeight,
  fullWidth,
  ...props
}: CardProps) => {
  const cardClassNames = clsx(styles.card, colour && colorStyles[colour], {
    [styles.border]: hasBorder,
    [styles.centered]: isCentered,
    [styles.clickable]: isClickable,
    [styles.elevated]: isElevated,
    [styles.selected]: isSelected,
    [styles.rounded]: rounded,
    [styles.fullHeight]: fullHeight,
    [styles.fullWidth]: fullWidth
  });

  const cardVars: Record<string, string> = {
    ...(rounded && { '--card-rounded': `var(${rounded})` })
  };

  return (
    <div
      data-test-id="Card"
      className={cardClassNames}
      style={cardVars}
      // aria-selected={isSelected} TODO move this onto an interactive element
    >
      <Box fullHeight={fullHeight} {...props}>
        {children}
      </Box>
    </div>
  );
};

export { Card };
